import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SearchAutocomplete.css';

const SearchAutocomplete = ({ 
  results, 
  isSearching, 
  showResults, 
  onHideResults, 
  searchQuery,
  hasResults 
}) => {
  const navigate = useNavigate();

  const handleResultClick = (result) => {
    if (result.route && result.id !== 'no-results') {
      navigate(result.route);
      onHideResults();
    }
  };

  const handleKeyDown = (e, result) => {
    if (e.key === 'Enter') {
      handleResultClick(result);
    }
  };

  if (!showResults || !searchQuery || searchQuery.length < 2) {
    return null;
  }

  return (
    <div className="search-autocomplete">
      <div className="search-autocomplete-header">
        <span className="search-query-highlight">"{searchQuery}"</span>
        {isSearching && <span className="search-loading">Recherche...</span>}
        {!isSearching && hasResults && (
          <span className="search-count">{results.length} résultat{results.length > 1 ? 's' : ''}</span>
        )}
      </div>

      <div className="search-results-list">
        {results.map((result, index) => (
          <div
            key={`${result.module}-${result.id}-${index}`}
            className={`search-result-item ${result.id === 'no-results' ? 'no-results' : ''}`}
            onClick={() => handleResultClick(result)}
            onKeyDown={(e) => handleKeyDown(e, result)}
            tabIndex={0}
            role="button"
          >
            <div className="result-icon">{result.icon}</div>
            <div className="result-content">
              <div className="result-title">{result.title}</div>
              <div className="result-subtitle">{result.subtitle}</div>
            </div>
            <div className="result-module">
              <span className="module-badge">{result.type}</span>
            </div>
          </div>
        ))}
      </div>

      {hasResults && (
        <div className="search-autocomplete-footer">
          <span className="search-tip">
            Cliquez sur un résultat pour y accéder
          </span>
        </div>
      )}
    </div>
  );
};

export default SearchAutocomplete;